var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_488_22173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.44736 1.93456C-0.0387009 3.42062 -0.0368797 5.83137 1.44736 7.31424C2.49998 8.36686 4.01472 8.67281 5.33687 8.23619L6.5534 9.45272C6.5534 9.45272 7.58508 8.57219 8.17103 9.15769C8.57852 9.56517 8.24934 10.2208 8.12915 10.6624C8.07679 10.8582 7.94885 11.288 8.55256 11.0963C8.87809 10.9966 9.55283 10.5905 10.0819 11.1186C10.61 11.6472 9.98217 12.7786 9.98217 12.7786L12.3333 12.7772L12.3324 10.4143L7.7458 5.82727C8.18424 4.50557 7.87828 2.98764 6.82566 1.93456C5.34234 0.452606 2.93159 0.451695 1.44736 1.93456ZM1.8644 6.25023C1.12638 5.15845 1.23929 3.66147 2.20769 2.69444C3.17426 1.72786 4.66942 1.6145 5.75892 2.35343L1.8644 6.25023Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_488_22173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.333008 0.800781)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key-icon.988c42409793e998e9b887db9e3b0166.svg";
export { ForwardRef as ReactComponent };